import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_DAYS_LIST = "SET_DAYS_LIST";
export const SET_CURRENT_DAY = "SET_CURRENT_DAY";
export const SET_INTERVENTIONS = "SET_INTERVENTIONS";
export const SET_FILTERED_AND_SORTED_INTERVENTIONS = "SET_FILTERED_AND_SORTED_INTERVENTIONS";
export const SET_ORDER_BY = "SET_ORDER_BY";
export const SET_SELECTED_DISPLAY_MODE = "SET_SELECTED_DISPLAY_MODE";
export const SET_INTERVENTIONS_BLOC_TYPES = "SET_INTERVENTIONS_BLOC_TYPES";
export const SET_DISPLAY_ENDED_INTERVENTIONS = "SET_DISPLAY_ENDED_INTERVENTIONS";
export const SET_SELECTED_TECHNICIAN_ID = "SET_SELECTED_TECHNICIAN_ID";
export const SET_BLOCS_HEIGHT = "SET_BLOCS_HEIGHT";
export const SET_SELECTED_DAY = "SET_SELECTED_DAY";
export const SET_DISPLAY_ONLY_IF_GOT_CERFA = "SET_DISPLAY_ONLY_IF_GOT_CERFA";
export const SEARCH_BY_INTERVENTION_NUMBER = "SEARCH_BY_INTERVENTION_NUMBER";
export const SET_PLANNIFIED_INTERVENTIONS = "SET_PLANNIFIED_INTERVENTIONS";

export const SET_UPDATING_BLOC = "SET_UPDATING_BLOC";
export const SET_CURRENT_INTERVENTION = "SET_CURRENT_INTERVENTION";
export const SET_BLOCS = "SET_BLOCS";
export const SET_PREVIEW = "SET_PREVIEW";
export const SET_CONTROL_SIGNATURE = "SET_CONTROL_SIGNATURE";
export const SET_SIGNATURE = "SET_SIGNATURE";
export const SET_CURRENT_TIME_SLOT = "SET_CURRENT_TIME_SLOT";
export const SET_EXPANDED_BLOC = "SET_EXPANDED_BLOC";

export const DEFAULT_WIDGET_VALUE = "";

export const TIME_SLOT_BLOC_TYPE_CODE = "PLAGE_INTERVENTION";
export const TIME_SLOT_START_DAY = "PLAGE_INTERVENTION_JOUR_ARRIVEE";
export const TIME_SLOT_START_TIME = "PLAGE_INTERVENTION_HEURE_ARRIVEE";
export const TIME_SLOT_END_DAY = "PLAGE_INTERVENTION_JOUR_DEPART";
export const TIME_SLOT_END_TIME = "PLAGE_INTERVENTION_HEURE_DEPART";

export const SIGNATURES_BLOC_TYPE_CODE = "SIGNATURES";

export const SET_IMPUTATION_REDIRECTION = "SET_IMPUTATION_REDIRECTION";

export const PAUSED_INTERVENTIONS_TYPE_ID = 3;
